import { Localisation } from '../../Missions/interfaces/missions.interface'

export interface User {
    _id: string
    lastname: string
    firstname: string
    email: string
    numero: string
    password: string
    city: string
    trajet: string[]
    villeEviter: Localisation[]
    disponibility: any[]
    typeMission: string
    domaineEviter: IDomaines[]
    domaineEntreprise: IDomaines
    localisation: [Localisation]
    siretEntreprise: string
    tva: string
    codeApe: string
    pieceJustificatif: [string]
    chiffreDaffaire: string
    role: UserRole
    idEntreprise: any //Nous attendons les types d'api renvoyés par le back-end
    createdAt: Date
    [key: string]: any
}

export interface UserModel {
    _id: string
    lastname: string
    firstname: string
    email: string
    numero: string
    password: string
    city: string
    trajet: string[]
    villeEviter: Localisation[]
    disponibility: any[]
    typeMission: string[]
    domaineEviter: IDomaines[]
    domaineEntreprise: IDomaines
    localisation: [Localisation]
    siretEntreprise: string
    tva: string
    codeApe: string
    pieceJustificatif: [string]
    chiffreDaffaire: string
    role: UserRole
    idEntreprise: any //Nous attendons les types d'api renvoyés par le back-end
    createdAt: Date
    [key: string]: any
}

export interface UtilisateurPrestataire extends User {}
export interface UtilisateurPrestataireForList extends UserModel {}

export type CreateAdminDto = Pick<User, 'firstname' | 'lastname' | 'password' | 'email'> & {
    passwordConfirm: User['password']
}

export interface IDomaines {
    _id: string
    name: string
}

export interface UserRole {
    _id: string
    type: string
}

export const recupererLocalisation = async (placeId: string, address: string): Promise<Localisation | null> => {
    return new Promise((resolve, reject) => {
        const geocoder = new window.google.maps.Geocoder();

        // Récupérer les coordonnées via le place_id
        geocoder.geocode({ placeId }, (results, status) => {
            if (status === 'OK' && results && results[0]) {
                const location = results[0].geometry.location;
                console.log(`Location (RecupererLocation): ${location}`)
                
                const newLocalisation: Localisation = {
                    latitude: location.lat(),
                    longitude: location.lng(),
                    address: address,
                    long_name: address
                };
                
                resolve(newLocalisation)
            } else {
                console.error('Recuperation Localisation Geocoding failed:', status);
                reject('Echec de la recuperation de la localisation a partir de cet id')
            }
        });
    })
};